import { render, staticRenderFns } from "./UpdateUserEmailComponent.vue?vue&type=template&id=bd8b48da&"
import script from "./UpdateUserEmailComponent.vue?vue&type=script&lang=js&"
export * from "./UpdateUserEmailComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports